// 最初に、ビューポートの高さを取得し、0.01を掛けて1%の値を算出して、vh単位の値を取得
let vh = window.innerHeight * 0.01;
// カスタム変数--vhの値をドキュメントのルートに設定
document.documentElement.style.setProperty('--vh', vh + 'px');

const vw = window.innerWidth;

//スマホ判定
const ua = navigator.userAgent;
let isSp = (ua.indexOf('iPad') > -1 || ua.indexOf('iPhone') > -1 || (ua.indexOf('Android') > -1 && ua.indexOf('Mobile') > -1));
if(vw >= 1024) {
  isSp = false;
}
const isPc = (!isSp);

let headerHeight;

$(function() {
  // ヘッダーの高さを変数で保持
  headerHeight = $('.site-header').outerHeight();
  // カスタム変数--vhの値をドキュメントのルートに設定
  document.documentElement.style.setProperty('--headerHeight', headerHeight + 'px');


  let $stickyHeader = $('.sticky-header');
  let $stickyLine = $('.fixed-line');
  $(window).on( 'scroll', function () {
    //スクロール位置を取得
    if ( $(this).scrollTop() < headerHeight + 100 ) {
      $stickyHeader.removeClass('is-show');
      $stickyLine.removeClass('is-show');
    } else {
      $stickyHeader.addClass('is-show');
      $stickyLine.addClass('is-show');
    }
  });

  if(isSp) {
    var fix    = $(".site-header");             //メニューオブジェクトを格納
    var fixTop = fix.offset().top;             //メニューの縦座標を格納
    var headerHeight = fix.outerHeight();
    $(window).scroll(function () {             //スクロールが発生したら開始
      if($(window).scrollTop() > fixTop) {    //スクロール時の縦座標がメニューの縦座標以上なら…
        fix.addClass("fixed");
        $('body').css('padding-top', headerHeight);
      } else {
        fix.removeClass("fixed");
        $('body').css('padding-top', 0);
      }
    });
  }




});

function setVw() {
  let vw = document.documentElement.clientWidth / 100;
  document.documentElement.style.setProperty('--vw', vw + 'px');
}
setVw();
window.addEventListener('resize', setVw);


$(function() {
  if(isSp) {
    $('.mv-slider__points-wrap').each(function() {
      $this = $(this);
      $this.closest('.mv-slider__item').find('.mv-slider__btns').before($this);
    });
  }
  $('.mv-slider').slick({
    arrows: true,
    lazyLoad: 'progressive'
  });

  $('.mv-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    const $nextSlide = $('.mv-slider').find(`.slick-slide[data-slick-index="${nextSlide}"]`);
    const $image = $nextSlide.find('img');
    
    if (!$image.hasClass('lazyloaded')) {
      lazySizes.loader.unveil($image.get(0));
    }
  });
});



//inview
const inview = document.querySelectorAll(".inview");
const options = {
  root: null, // 今回はビューポートをルート要素とする
  rootMargin: "-10% 0px", // ビューポートの中心を判定基準にする
  threshold: 0 // 閾値は0
};
const observer = new IntersectionObserver(doWhenIntersect, options);
// それぞれのboxを監視する
inview.forEach(item => {
  observer.observe(item);
});
/**
 * 交差したときに呼び出す関数
 * @param entries
 */
function doWhenIntersect(entries) {
  // 交差検知をしたもののなかで、isIntersectingがtrueのDOMを色を変える関数に渡す
  entries.forEach(entry => {
    if (entry.isIntersecting) {
			entry.target.classList.add("move");
		}
		else {
			//画面外になった時の処理
			//entry.target.classList.remove("active");
		}
  });
}





//メニュー開閉
$(function() {
  $('.menu-trigger').on('click', function() {
    $(this).toggleClass('active');
    $('.overlay').toggleClass('active');
    $('body').toggleClass('menu-open');
  });
  $('.close-btn').on('click', function() {
    $('.menu-trigger').trigger('click');
  });
});


$('.overlay').on('click', function() {
  $('.menu-trigger').trigger('click');
});


$('.sp-menu .menu__link').each(function() {
  $this = $(this);
  if( $this.next('ul').length > 0 ) {
    $this.append('<span class="toggle"></div>');
  }
});

$('.sp-menu .menu__link').on('click', function(e) {
  e.preventDefault();
  e.stopPropagation();
  $this = $(this);
  if($this.attr('href') == '#') {
    $this.next('ul').slideToggle();
  }
  else {
    location.href = $this.attr('href');
  }
});

//$(document).on('click','.toggle', function(e) {
//  e.preventDefault();
//  $(this).closest('.menu__link').next('ul').slideToggle();
//});

// ページ外リンク
//$(window).on('load', function() {
//  var headerHeight = $('.header__bottom-wrap').outerHeight(); //ヘッダの高さ
//  if(document.URL.match("#")) {
//    var str = location.href ;
//    var cut_str = "#";
//    var index = str.indexOf(cut_str);
//    var href = str.slice(index);
//    var target = href;
//    var position = $(target).offset().top - headerHeight;
//    $("html, body").scrollTop(position);
//    return false;
//  }
//});
//
//$(function () {
//  var headerHeight = $('.header__bottom-wrap').outerHeight(); //ヘッダの高さ
//  $('a').on('click', function(){
//    if($(this).attr('href').match("#")) {
//      var str = $(this).attr('href');
//      var cut_str = "#";
//      var index = str.indexOf(cut_str);
//      var href = str.slice(index);
//      var target = href;
//      var position = $(target).offset().top - headerHeight;
//      $("html, body").animate(
//        {scrollTop: position}, 500)
//      return false;
//    }
//  });
//});

